import React from 'react';
import PropTypes from 'prop-types';
import { liftsColors } from "../../config/styles";
import { TRACK_STATE_DIFFICULTY } from "../../config/constants";

const LabelLift = ({ text, coords, state, id = '', isOpen }) => (
	<g id={`label-lift${id}`} transform={coords ? `translate(${coords})` : null}>
		<circle
			fill={isOpen || state === TRACK_STATE_DIFFICULTY ? liftsColors.open[0] : liftsColors.closed[1]}
			cx="13"
			cy="13"
			r="13"
		/>
		<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
		<g strokeWidth="1"
			 transform="translate(9.000000, 4.000000)"
			 fill={isOpen || state === TRACK_STATE_DIFFICULTY ? liftsColors.open[2] : liftsColors.closed[1]}
			 fontFamily="OpenSans-Bold, Open Sans"
			 fontSize="12"
			 fontWeight="bold"
		>
			<text>{
				typeof text === 'string' || typeof text === 'number' ?
					<tspan x="0.0751953125" y="13">{text}</tspan> :
					text
			}</text>
		</g>
	</g>
);

LabelLift.defaultProps = {
	textCoordsX: '7.80175781',
	textCoordsY: '22',
};

LabelLift.propTypes = {
	coords: PropTypes.string,
	text: PropTypes.any,
	textCoordsX: PropTypes.string,
	textCoordsY: PropTypes.string,
	isOpen: PropTypes.bool
};

export default LabelLift;
